import "./ZoomTo.scoped.css";
import IComponent from "components/commons/IComponent";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import Search from "@arcgis/core/widgets/Search";
import geometryTools from "utils/geometryTools";
import esriRequest from "@arcgis/core/request";
import GetArcGISToken from "utils/GetArcGISToken";

let distictPopupOptions = {
  zoom_to_dropdown_01: [],
  zoom_to_dropdown_02: [],
};
class ClassName extends IComponent {
  constructor(props) {
    super(props);
    this.state = { searchInput: { district: "null", district_area: "null" } };
    this.searchWidgetPh = this.createRef();
  }
  componentDidMount() {
    this.initZoomToDropdownSelect();
    this.initSearchWidget();
  }
  async initZoomToDropdownSelect() {
    let zoom_to_dropdown_select = {};
    if (distictPopupOptions.zoom_to_dropdown_01.length === 0) {
      let token = GetArcGISToken.token;
      let url1 = `${
        this.$config.DistrictLayerList.districtLayerUrl
      }?f=json&outFields=NAME&orderByFields=NAME&where=1=1&returnGeometry=false&token=${token}`;
      let dcSelectOptions = await esriRequest(url1, {});
      dcSelectOptions = dcSelectOptions.data;
      if ("features" in dcSelectOptions) {
        zoom_to_dropdown_select.zoom_to_dropdown_01 = Array.from(
          new Set(dcSelectOptions.features.map((i) => i.attributes.NAME))
        );
      }
      let url2 = `${
        this.$config.DistrictLayerList.districtAreaLayerUrl
      }?f=json&returnDistinctValues=true&outFields=GE_POST&orderByFields=GE_POST&where=1=1&returnGeometry=false&token=${token}`;
      let dcAreaSelectOptions = await esriRequest(url2, {});
      dcAreaSelectOptions = dcAreaSelectOptions.data;
      if ("features" in dcAreaSelectOptions) {
        zoom_to_dropdown_select.zoom_to_dropdown_02 = Array.from(
          new Set(
            dcAreaSelectOptions.features
              .filter((i) => typeof i.attributes.GE_POST === "string")
              .map((i) => i.attributes.GE_POST.toUpperCase())
          )
        );
        zoom_to_dropdown_select.zoom_to_dropdown_02.sort((a, b) =>
          a.localeCompare(b)
        );
      }
      distictPopupOptions = zoom_to_dropdown_select;
      this.setState({});
    }
  }
  async refreshDistrictDisplay(districtName, field) {
    let token = GetArcGISToken.token;
    let url = "";
    switch (field) {
      case "district":
        url = `${
          this.$config.DistrictLayerList.districtLayerUrl
        }?f=json&where=NAME='${
          distictPopupOptions.zoom_to_dropdown_01[districtName]
        }'&returnGeometry=true&token=${token}`;
        break;
      case "district_area":
        url = `${
          this.$config.DistrictLayerList.districtAreaLayerUrl
        }?f=json&where=UPPER(GE_POST)='${
          distictPopupOptions.zoom_to_dropdown_02[districtName]
        }'&returnGeometry=true&token=${token}`;
        break;
      default:
        return;
    }

    let districtResult = await esriRequest(url, {});
    districtResult = districtResult.data;
    if ("features" in districtResult && districtResult.features.length > 0) {
      let tmpGeometrys = [];
      for (let i = 0; i < districtResult.features.length; i++) {
        let feature = districtResult.features[i];
        let tmpRings = feature.geometry.rings;
        let tmpGeometry = new geometryTools.Polygon({
          rings: tmpRings,
          spatialReference: { wkid: 102140 },
        });
        tmpGeometrys.push(tmpGeometry);
      }
      geometryTools.refreshGraphicByLayerId(
        this.props.mapView,
        "highlightLayerForDistrict",
        tmpGeometrys,
        true
      );
    } else {
      geometryTools.refreshGraphicByLayerId(
        this.props.mapView,
        "highlightLayerForDistrict",
        null,
        false
      );
    }
  }
  initSearchWidget() {
    let slopeLayer = this.props.mapView.map.allLayers.find(
      (i) => i.title === "Man Made Slope - Query"
    );
    slopeLayer = new geometryTools.FeatureLayer({
      url: `${
        this.$config.serverUrl
      }/rest/services/ManMadeSlope_Test/FeatureServer/0`,
      popupEnabled: false,
    });
    let searchSrcSlopeIndex = this.$config.locationSearchSource.findIndex(
      (i) => i.name == "Man Made Slope"
    );
    this.$config.locationSearchSource[searchSrcSlopeIndex] = {
      layer: slopeLayer,
      searchFields: ["SLOPE_NO"],
      displayField: "SLOPE_NO",
      exactMatch: false,
      outFields: ["*"],
      name: "Man Made Slope",
      placeholder: "11NW-D/CR 111",
      maxSuggestions: `10`,
      suggestionsEnabled: true,
      minSuggestCharacters: 2,
      popupEnabled: false,
      resultGraphicEnabled: true,
      resultSymbol:
        this.props.mapType == 3
          ? geometryTools.highlightSymbol["polygon-3d"]
          : geometryTools.highlightSymbol.polygon,
    };
    console.log("check src", this.$config.locationSearchSource);
    var searchWidget = (this.searchWidget = window.searchWidget = new Search({
      view: this.props.mapView,
      includeDefaultSources: false,
      locationEnabled: false,
      sources: this.$config.locationSearchSource,
      maxResults: 10,
      popupEnabled: false,
    }));
    searchWidget.on("suggest-complete", function(event) {
      console.log("Search result focus:", event);

      if (event.numResults === 0) {
        let searchTerm = event.searchTerm;
        const regexPartial = /^\d[a-zA-Z]{2}$/;
        // const regex2 = /^(\d[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z])(\d+)$/;
        // const regex3 = /^([0-9a-zA-Z-]+\/[a-zA-Z]+)(\d+)$/; //11sw-a/f142
        const regex1space = /^([0-9a-z-]+\/[a-z]) (\d+)$/; //11sw-a/f 142
        // const regexOneLetter = /^([0-9a-z-]+\/[a-z])(\d+)$/;
        // const regexTwoLetters = /^([0-9a-z-]+\/[a-z]{2})(\d+)$/;
        // const regex = /^([a-z0-9-]+\/[a-z]+)(\d+)$/;

        const regex_1 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]\d{1}$/; // 1 letters 1 d (4 spaces)
        const regex_2 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]\d{2}$/; // 1 letters 2 d (3 spaces)
        const regex_3 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]\d{3}$/; // 1l 3d  (2 spaces)
        const regex_4 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]\d{4}$/; // 1l 4d (1 spaces)
        const regex_5 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]{2}\d{1}$/; // 2 1 (3 spaces)
        const regex_6 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]{2}\d{2}$/; // (2 sapces)
        const regex_7 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]{2}\d{3}$/; // (1 spaces)
        const regex_8 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]{2}\d{4}$/; //(no spaces)

        function separateAndRecombine(inputString, num) {
          // Use a regular expression to separate the non-digit and digit parts of the string
          const match = inputString.match(/(.+?)(\d+)$/);

          // Check if the match was successful
          if (match) {
            const firstPart = match[1]; // Non-digit characters
            const secondPart = match[2]; // Digit characters at the end

            // Recombine with a space
            return num === 2
              ? `%${firstPart}  ${secondPart}`
              : num === 3
              ? `%${firstPart}   ${secondPart}`
              : num === 1
              ? `%${firstPart} ${secondPart}`
              : num === 4
              ? `%${firstPart}    ${secondPart}`
              : `%${firstPart}${secondPart}`;
          } else {
            return "The input string was not in the expected format.";
          }
        }
        if (searchTerm && regexPartial.test(searchTerm)) {
          let modifiedValue = "%" + searchTerm;
          searchWidget.searchTerm = modifiedValue;

          // Crucial: Use setTimeout to allow the widget to update
          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (
          searchTerm &&
          (regex_2.test(searchTerm) || regex_5.test(searchTerm))
        ) {
          const modifiedString = separateAndRecombine(searchTerm, 3);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (
          searchTerm &&
          (regex_3.test(searchTerm) || regex_6.test(searchTerm))
        ) {
          const modifiedString = separateAndRecombine(searchTerm, 2);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (
          searchTerm &&
          (regex_4.test(searchTerm) ||
            regex_7.test(searchTerm) ||
            regex1space.test(searchTerm))
        ) {
          const modifiedString = separateAndRecombine(searchTerm, 1);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (searchTerm && regex_1.test(searchTerm)) {
          const modifiedString = separateAndRecombine(searchTerm, 4);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (searchTerm && regex_8.test(searchTerm)) {
          const modifiedString = separateAndRecombine(searchTerm, 0);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        }
      }
    });

    searchWidget.on("search-complete", function(event) {
      console.log("Search result focus:", event);

      if (event.numResults === 0) {
        // searchWidget.suggestionsEnabled = true;
        let searchTerm = event.searchTerm;
        const regexPartial = /^\d[a-zA-Z]{2}$/;
        // const regex2 = /^(\d[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z])(\d+)$/;
        // const regex3 = /^([0-9a-zA-Z-]+\/[a-zA-Z]+)(\d+)$/; //11sw-a/f142
        const regex1space = /^([0-9a-z-]+\/[a-z]) (\d+)$/; //11sw-a/f 142
        // const regexOneLetter = /^([0-9a-z-]+\/[a-z])(\d+)$/;
        // const regexTwoLetters = /^([0-9a-z-]+\/[a-z]{2})(\d+)$/;
        // const regex = /^([a-z0-9-]+\/[a-z]+)(\d+)$/;

        const regex_1 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]\d{1}$/; // 1 letters 1 d (4 spaces)
        const regex_2 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]\d{2}$/; // 1 letters 2 d (3 spaces)
        const regex_3 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]\d{3}$/; // 1l 3d  (2 spaces)
        const regex_4 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]\d{4}$/; // 1l 4d (1 spaces)
        const regex_5 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]{2}\d{1}$/; // 2 1 (3 spaces)
        const regex_6 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]{2}\d{2}$/; // (2 sapces)
        const regex_7 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]{2}\d{3}$/; // (1 spaces)
        const regex_8 = /^\d{1,2}[a-zA-Z]{2}-[a-zA-Z]\/[a-zA-Z]{2}\d{4}$/; //(no spaces)

        function separateAndRecombine(inputString, num) {
          // Use a regular expression to separate the non-digit and digit parts of the string
          const match = inputString.match(/(.+?)(\d+)$/);

          // Check if the match was successful
          if (match) {
            const firstPart = match[1]; // Non-digit characters
            const secondPart = match[2]; // Digit characters at the end

            // Recombine with a space
            return num === 2
              ? `%${firstPart}  ${secondPart}`
              : num === 3
              ? `%${firstPart}   ${secondPart}`
              : num === 1
              ? `%${firstPart} ${secondPart}`
              : num === 4
              ? `%${firstPart}    ${secondPart}`
              : `%${firstPart}${secondPart}`;
          } else {
            return "The input string was not in the expected format.";
          }
        }
        if (searchTerm && regexPartial.test(searchTerm)) {
          let modifiedValue = "%" + searchTerm;
          searchWidget.searchTerm = modifiedValue;

          // Crucial: Use setTimeout to allow the widget to update
          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (
          searchTerm &&
          (regex_2.test(searchTerm) || regex_5.test(searchTerm))
        ) {
          const modifiedString = separateAndRecombine(searchTerm, 3);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (
          searchTerm &&
          (regex_3.test(searchTerm) || regex_6.test(searchTerm))
        ) {
          const modifiedString = separateAndRecombine(searchTerm, 2);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (
          searchTerm &&
          (regex_4.test(searchTerm) ||
            regex_7.test(searchTerm) ||
            regex1space.test(searchTerm))
        ) {
          const modifiedString = separateAndRecombine(searchTerm, 1);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (searchTerm && regex_1.test(searchTerm)) {
          const modifiedString = separateAndRecombine(searchTerm, 4);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        } else if (searchTerm && regex_8.test(searchTerm)) {
          const modifiedString = separateAndRecombine(searchTerm, 0);
          searchWidget.searchTerm = modifiedString;

          setTimeout(() => {
            searchWidget.suggest(); // Trigger suggestions again
          }, 0); // A delay of 0 is sufficient
        }
      }
    });
    var container = document.createElement("DIV");
    this.searchWidgetPh.current.appendChild(container);
    searchWidget.container = container;
  }
  componentWillUnmount() {}
  onChangeHandler(field, value, values) {
    let newState = { ...this.state.searchInput };
    newState[field] = value;
    console.debug(newState);
    this.refreshDistrictDisplay(value, field);
    this.setState({
      searchInput: newState,
    });
  }
  render() {
    const ZoomToLocation = { height: "70px" };
    const ZoomToLocation_Padding = { padding: "25px 20px" };
    const ZoomToLocation_Margin = { margin: "20px 0px 0px 0px" };

    if (!distictPopupOptions) return;
    return (
      <div>
        <div className="PanelTitle" style={ZoomToLocation}>
          <span>Zoom To Location</span>
        </div>
        <div className="SubPanelContent" style={ZoomToLocation_Padding}>
          <div ref={this.searchWidgetPh} />
          <div className="EqualWidthChildren" style={ZoomToLocation_Margin}>
            <EditableDatagridCell
              key="zoom_to_dropdown_01"
              cellInfo={{
                colDef: {
                  field: "district",
                  dataType: "dropdown",
                  values: distictPopupOptions.zoom_to_dropdown_01,
                  naText: "- District -",
                },
                row: this.state.searchInput,
                key: "zoom_to_dropdown_01",
              }}
              onChange={this.onChangeHandler.bind(this)}
            />
            <EditableDatagridCell
              key="zoom_to_dropdown_02"
              cellInfo={{
                colDef: {
                  field: "district_area",
                  dataType: "dropdown",
                  values: distictPopupOptions.zoom_to_dropdown_02,
                  naText: "- District Area -",
                },
                row: this.state.searchInput,
                key: "zoom_to_dropdown_02",
              }}
              onChange={this.onChangeHandler.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ClassName;
